export function citysprintVehicleCardDisplayTitle(name) {
  const s = String(name ?? '').trim();
  if (!s) {
    return '';
  }
  const stripped = s.replace(/\s*\([^)]*\)\s*$/, '').trim();
  return stripped || s;
}

export function getVehicleCardOrientation(vehicleCount) {
  return vehicleCount <= 2 ? 'horizontal' : 'vertical';
}

export function getVehicleGridTemplateColumns(vehicleCount) {
  const columns = Math.min(Math.max(vehicleCount, 1), 4);
  return {
    xs: '1fr',
    sm: `repeat(${columns}, minmax(0, 1fr))`,
  };
}
